// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/message-control-center/template-list.css
// module id = 2046
// module chunks = 0